import React from 'react';

import { Form, FormCheckProps } from 'react-bootstrap';

export interface Props extends FormCheckProps {
    checked?: boolean;
}

export const Switch: React.FC<Props> = (props) => <Form.Check type="switch" {...props} />;
